jQuery( document ).ready(function() {
    
    const buttonContact = document.querySelector(".header-normal .button-contact")
    const main = document.querySelector("main")
    const depliant = document.querySelector("header .depliant")
    const dropmenus = Array.from(document.querySelectorAll(".header-normal ul.dropdown-menu"))
    
    buttonContact.addEventListener("click", () => {
        if(buttonContact.classList.contains("open")){
            depliant.style.maxHeight = "0"
            if(objects.is_front_page){
                main.style.paddingTop = 0 + "px"
            } else {
                main.style.paddingTop = 0 + "px"
            }
            header.style.background = "rgba(255, 255, 255, 0.6)"
            dropmenus.forEach(element => {
                element.style.background = "rgba(255, 255, 255, 0.6)"
            })
            buttonContact.classList.remove("open")
            buttonContact.classList.remove("active")
            buttonContact.classList.add("close")
            headerScroll()
        } else {
            depliant.style.maxHeight = depliant.querySelector(".depliant-inner").getBoundingClientRect().height + "px"
            if(objects.is_front_page){
                main.style.paddingTop = depliant.querySelector(".depliant-inner").getBoundingClientRect().height + "px"
            } else {
                main.style.paddingTop = depliant.querySelector(".depliant-inner").getBoundingClientRect().height + "px"
            }
            header.style.background = "white"
            dropmenus.forEach(element => {
                element.style.background = "white"
            })
            buttonContact.classList.add("open")
            buttonContact.classList.remove("close")
            buttonContact.classList.add("active")
        }
    })

    window.addEventListener("resize", () => {
        if(window.innerWidth >= 992) {
            if(buttonContact.classList.contains("open")){
                depliant.style.maxHeight = depliant.querySelector(".depliant-inner").getBoundingClientRect().height + "px"
                if(objects.is_front_page){
                    main.style.paddingTop = depliant.querySelector(".depliant-inner").getBoundingClientRect().height + "px"
                } else {
                    main.style.paddingTop = depliant.querySelector(".depliant-inner").getBoundingClientRect().height + "px"
                }
                header.style.background = "white"
            } else {
                depliant.style.maxHeight = "0"
                if(objects.is_front_page){
                    main.style.paddingTop = 0 + "px"
                } else {
                    main.style.paddingTop = 0 + "px"
                }
            }
        } else {
            main.style.paddingTop = 0 + "px"
        }
    })

    const header = document.querySelector(".navbar.navbar-expand-lg")
    function headerScroll(){
        if (window.pageYOffset === 0){
            if(buttonContact.classList.contains("open")){
                header.style.background = "white"
                dropmenus.forEach(element => {
                    element.style.background = "white"
                })
            } else {
                header.style.background = "rgba(255, 255, 255, 0.6)"
                dropmenus.forEach(element => {
                    element.style.background = "rgba(255, 255, 255, 0.6)"
                })
            }
        } else {
            header.style.background = "white"
            dropmenus.forEach(element => {
                element.style.background = "white"
            })
        }
    }
    headerScroll()
    window.addEventListener("scroll", headerScroll)
})